// extracted by mini-css-extract-plugin
export default {"card":"Team_card__+Gxw1","cardContainer":"Team_cardContainer__VFXqA","animate":"Team_animate__Dq9p0","socials":"Team_socials__cHTth","postHead":"Team_postHead__G4W3g"};